import { useEffect } from "react";

export default function MailboxEmailModal({
  mailbox,
  draft,
  message,
  isLoading = false,
  isSending = false,
  error = "",
  onMessageChange,
  onSend,
  onClose,
}) {
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape" && !isSending) onClose();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [isSending, onClose]);

  return (
    <div
      className="admin-modal-backdrop"
      role="presentation"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget && !isSending) onClose();
      }}
    >
      <section className="admin-modal" role="dialog" aria-modal="true" aria-labelledby="mailbox-email-title">
        <div className="admin-modal-header">
          <div>
            <p className="admin-page-eyebrow">Mail notification</p>
            <h2 id="mailbox-email-title">Email mailbox #{mailbox.number}</h2>
            <p>Review the configured message and make any one-time changes before sending.</p>
          </div>
          <button
            className="admin-modal-close"
            type="button"
            aria-label="Close email composer"
            onClick={onClose}
            disabled={isSending}
          >
            &times;
          </button>
        </div>

        <form onSubmit={onSend}>
          <div className="admin-modal-body">
            {isLoading && <p className="admin-empty-state">Preparing email...</p>}
            {!isLoading && error && !draft && <p className="admin-empty-state admin-error-state" role="alert">{error}</p>}
            {!isLoading && draft && (
              <div className="admin-form admin-email-draft-form">
                <label>
                  To
                  <input type="email" value={draft.recipientEmail} readOnly />
                </label>
                <label>
                  Subject
                  <input type="text" value={draft.subject} readOnly />
                </label>
                <label className="admin-field-wide">
                  Message
                  <textarea
                    value={message}
                    onChange={(event) => onMessageChange(event.target.value)}
                    maxLength={draft.maxLength}
                    required
                    autoFocus
                  />
                </label>
                {error && <p className="admin-form-error admin-field-wide" role="alert">{error}</p>}
              </div>
            )}
          </div>
          <div className="admin-modal-footer">
            <div className="admin-form-actions">
              <button className="admin-button admin-button-secondary" type="button" onClick={onClose} disabled={isSending}>
                Cancel
              </button>
              <button
                className="admin-button admin-button-primary"
                type="submit"
                disabled={isLoading || isSending || !draft || !message.trim()}
              >
                {isSending ? "Sending..." : "Send Email"}
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>
  );
}
